import { useEffect, useState } from "react";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import db from "../firebase";

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    const visitorsRef = doc(db, "visitors", "global"); // keep it here
    const hasVisited = localStorage.getItem("hasVisited");

    const incrementVisit = async () => {
      try {
        const docSnap = await getDoc(visitorsRef);

        if (docSnap.exists()) {
          const currentCount = docSnap.data().count;

          if (!hasVisited) {
            await updateDoc(visitorsRef, { count: currentCount + 1 });
            localStorage.setItem("hasVisited", "true");
            setVisitorCount(currentCount + 1);
          } else {
            setVisitorCount(currentCount);
          }
        } else {
          await setDoc(visitorsRef, { count: 1 });
          localStorage.setItem("hasVisited", "true");
          setVisitorCount(1);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    incrementVisit();
  }, []);

  return (
    <div className="text-sm text-gray-600 dark:text-gray-300">
      Visitors: {visitorCount !== null ? visitorCount : "Loading..."}
    </div>
  );
};

export default VisitorCounter;